/**
 * Сторадж с ссылками на страницы, чтобы централизовано делать абсолютные переходы в проекте
 */
export namespace RoutesStorage {
    export const Organization = {
        edit: '/organization/profile',
        usersList: '/organization/users',
        laboratoryEdit: '/organization/labs',
    };


    export const Equipment = {
        list: '/equipment',
        view(id: number) {
            return `/equipment/view/${id}`;
        },
        edit(id: number) {
            return `/equipment/edit/${id}`;
        }
    };

    /**
     * Страницы Объектов
     */
    export const WorkingObject = {
        list: '/objects',
        view(id: number) {
            return `/objects/${id}/view`;
        },
        viewEquipment(id: number) {
            return this.view(id) + `/equipment`;
        },
        edit(id: number) {
            return `/objects/${id}/edit`;
        },
    };

    /**
     * Страницы технических устройств
     */
    export const TechnicalDevice = {
        new(objectId: number) {
            return `/objects/technical-device/${objectId}/new`;
        },
        view(id: number) {
            return `/objects/technical-device/${id}/view`;
        },
        viewElements(id: number) {
            return this.view(id) + '/conclusion';
        },
        viewElementGroups(id: number) {
            return this.view(id) + '/elements-groups';
        },
        edit(id: number) {
            return `/objects/technical-device/${id}/edit`;
        },
    };

    export const TechnicalDeviceElement = {
        new(deviceId: number) {
            return `/objects/element/${deviceId}/new`;
        },
    };

    /**
     * Страницы Типоразмеров (групп элементов)
     */
    export const ElementGroup = {
        new(technicalDeviceId: number) {
            return `/objects/element-group/${technicalDeviceId}/new`;
        },
        view(id: number) {
            return `/objects/element-group/${id}/view`;
        },
        edit(id: number) {
            return `/objects/element-group/${id}/edit`;
        },
    };

    export const Conclusion = {
        list: `/objects/conclusions`,
        new(elementId: number, techcardId: number) {
            return `/objects/conclusions/${elementId}/${techcardId}/new`;
        },
        view(id: number) {
            return `/objects/conclusions/${id}/view`;
        },
        edit(id: number, elementId: number, techcardId: number) {
            return `/objects/conclusions/${elementId}/${techcardId}/${id}/edit`;
        },
    };
}
